<form #dialogForm="ngForm">
  <h2 mat-dialog-title id="aria_dialog_title" cdkFocusInitial tabindex="-1">{{data.title}}</h2>
  <mat-dialog-content>
    <div class="dialog__content" [innerHtml]="data.content"></div>
    @if (data.items) {
      <dl class="dialog__items">
        @for (item of data.items | keyvalue; track item) {
          <dt>{{item.key | titleCasePipe}}</dt>
          <dd>{{item.value}}</dd>
        }
      </dl>
    }
    @if (data?.form?.fields?.length) {
      <div class="dialog__fields">
        @for (field of data?.form?.fields; track field) {
          @if (field.type === 'textarea') {
            <mat-form-field floatLabel="always">
              <mat-label>{{ field.label }}</mat-label>
              <textarea matInput
                [(ngModel)]="formData[field.name]"
                #fieldModel="ngModel"
                [name]="field.label"
                [placeholder]="field.placeholder"
                trim-whitespace
                [required]="field.required">
              </textarea>
              <mat-error>
                {{ validationService
                .getFieldErrorMessage(
                field.label, fieldModel) }}
              </mat-error>
            </mat-form-field>
          }
          @if (field.type === 'select') {
            <mat-form-field floatLabel="always">
              <mat-label>{{ field.label }}</mat-label>
              <mat-select
                [(ngModel)]="formData[field.name]"
                #fieldModel="ngModel"
                [name]="field.label"
                [required]="field.required">
                @for (opt of field.options; track opt) {
                  <mat-option
                    [value]="opt">
                    {{ opt }}
                  </mat-option>
                }
              </mat-select>
              <mat-error>
                {{ validationService
                .getFieldErrorMessage(
                field.label, fieldModel) }}
              </mat-error>
            </mat-form-field>
          }
        }
      </div>
    }
    @for (table of data.tables; track table; let i = $index) {
      <div class="dialog__table">
        <h3> {{table.header}} </h3>
        <table mat-table [dataSource]="table.rows">
          @for (columnDef of columnDefinitions[i]; track columnDef; let columnIndex = $index) {
            <ng-container [matColumnDef]="columnDef">
              @if (table.hasColumnHeaderRow) {
                <th mat-header-cell *matHeaderCellDef [class]="'dialog__table--' + table.columnMetadata[columnIndex].contentAlignment.toString().toLowerCase()">
                  {{table.columnMetadata[columnIndex].title}}
                </th>
              }
              <td mat-cell *matCellDef="let row" [class]="'dialog__table--' + table.columnMetadata[columnIndex].contentAlignment.toString().toLowerCase()">
                {{row[columnIndex]}}
              </td>
              @if (table.footer?.length > 0) {
                <td mat-footer-cell *matFooterCellDef [class]="'dialog__table--' + table.columnMetadata[columnIndex].contentAlignment.toString().toLowerCase()">
                  {{table.footer[columnIndex]}}
                </td>
              }
            </ng-container>
          }
          @if (table.hasColumnHeaderRow) {
            <tr mat-header-row *matHeaderRowDef="columnDefinitions[i]; sticky: true"></tr>
          }
          <tr mat-row *matRowDef="let row; columns: columnDefinitions[i];"></tr>
          @if (table.footer?.length > 0) {
            <tr mat-footer-row class="dialog__table--footer" *matFooterRowDef="columnDefinitions[i]"></tr>
          }
        </table>
      </div>
    }
  </mat-dialog-content>
  @if (data.actions?.length > 0) {
    <mat-dialog-actions align="end" class="dialog__actions">
      @for (action of data.actions; track action) {
        @if (action.solidBackground) {
          <button matButton="filled" [color]="action.color"
            (click)="onClick_actionClose(action.close, dialogForm,
              action.click)">{{action.text}}</button>
        }
        @if (!action.solidBackground) {
          <button matButton [color]="action.color"
            (click)="onClick_actionClose(action.close, dialogForm,
              action.click)">{{action.text}}</button>
        }
      }
    </mat-dialog-actions>
  }
</form>